module.exports = __webpack_public_path__ + "img/main_19.8968b48a.jpg";